// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"67ecc1a7","484":"2c7f8d2c","551":"fd02a715","570":"6c21a668","851":"b6c63726"}[chunkId] + ".chunk.js";
};